import {Component, effect, inject, Injector, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';
import {
  REF_MODEL_STORE,
  RefModelStoreService,
  TakeUntilComponentDestroy
} from '@q9elements/ui-kit/common';
import {RefModelSidebarService} from '@q9elements/ui-kit/refmodels';
import {RmeNodeDaoAbstractService} from '../../../core/abstract/rme-node-dao-abstract.service';
import {UpdateTreeService} from '../../../services/update-tree.service';

@Component({
  selector: 'app-classification-tab',
  templateUrl: './classification-tab.component.html'
})
export class ClassificationTabComponent extends TakeUntilComponentDestroy implements OnInit {
  private injector = inject(Injector);
  private rmeStore = inject(RefModelStoreService);
  private updateTreeService = inject(UpdateTreeService);
  private refModelSidebarService = inject(RefModelSidebarService);
  private rmeNodeDaoAbstractService = inject(RmeNodeDaoAbstractService);

  public tagsControl = new FormControl();

  ngOnInit() {
    this.setTags();
    this.listenForTagChanges();
  }

  private setTags() {
    effect(
      () => {
        const currentTags = this.refModelSidebarService.refModelNode()?.tags;

        this.tagsControl.setValue(currentTags, {emitEvent: false});
      },
      {allowSignalWrites: true, injector: this.injector}
    );
  }

  private listenForTagChanges() {
    this.tagsControl.valueChanges.pipe(this.takeUntilComponentDestroy()).subscribe(newTags => {
      this.updateNodeTags(newTags);
    });
  }

  private updateNodeTags(tags: string[]) {
    const updateObject = {tags};

    this.rmeNodeDaoAbstractService
      .updateNode(
        this.refModelSidebarService.refModelNode().refModel,
        this.refModelSidebarService.refModelNode().identity,
        updateObject
      )
      .subscribe(res => {
        this.refModelSidebarService.refModelNode().tags = [...res.tags];

        this.rmeStore.set(
          REF_MODEL_STORE.SELECTED_NODE,
          this.refModelSidebarService.refModelNode()
        );
        this.updateTreeService.set('updateNodeInTree', {
          value: res.tags,
          property: 'tags',
          nodeId: this.refModelSidebarService.refModelNode().identity
        });
      });
  }
}
